module.exports = "https://static.wanderu.com/static/media/fr.81d43a15.svg";